import React, { useEffect, useState } from "react";
import "./knowledge.scss";
import alert from "../../Assets/svg/alert.svg";
import Button from "../modules/Button";
import FooterText from "../modules/FooterText";
import ModalComponent from "../modules/Modal";
import Input from "../modules/Input";
import clock from "../../Assets/svg/clock grey.svg";
import tick from "../../Assets/svg/tick wave.svg";
import { GetBaseUrl } from "../modules/getBaseUrl";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

function KnowledgeSection() {
  const [dropType, setDropType] = useState("");
  const navigate = useNavigate();
  const [transaction, setTransaction] = useState({
    num: "",
    amount: "",
    date: "",
  });
  const personalInfo = useSelector((state) => state.personal.personalInfo);

  const [ModalData, setModalData] = useState({
    show: false,
    type: "",
    title: "Complete Dropout Request",
    desc: "Please provide us with the Refund Transaction details so we verify and  complete your dropout request",
  });
  const setCollect = () => {
    // console.log("info in set", info);
    return (
      <div className="field-set">
        <div className="md-desc">
          Please provide us with the Refund Transaction details so we verify and
          complete your dropout request
        </div>
        <div className="field-one field">
          <Input
            placeholder={"Scholarship amount UTR/Transaction number"}
            onChange={(e) =>
              setTransaction({
                ...transaction,
                num: e.match(/[a-zA-Z0-9]+/g)?.join(""),
              })
            }
            value={transaction.num}
          />
        </div>
        <div className="field-two field">
          <Input
            value={transaction.amount}
            inputType={"rupee"}
            onChange={(e) =>
              setTransaction({
                ...transaction,
                amount: e.match(/\d+/g)?.join(""),
              })
            }
            placeholder={"Enter Amount"}
          />
        </div>
        <div className="field-three field">
          <Input
            type="date"
            placeholder={"Transaction Date"}
            onChange={(e) => setTransaction({ ...transaction, date: e })}
            value={transaction.date}
          />
        </div>
      </div>
    );
  };
  const getImpact = () => {
    // let url = GetBaseUrl(window.location.href);
    // window.location.replace(url + "/application/impact");

    navigate("/application/impact");
  };

  const setConfirm = () => {
    return (
      <div className={`confirm-text `}>
        <div className="confirm-text-div">
          <img className="sad" src={tick} alt="happy" />
        </div>
        <div className={`md-title`}>Dropout Request Submitted!</div>
        <div className=" md-desc">
          <div>
            An IDFC FIRST Bank representative will confirm the transaction
            details provided by you and complete your request
          </div>
          <div>
            You will receive confirmation of your dropout status on your email{" "}
            <span>{personalInfo?.email}</span>
          </div>
          <div>Sorry to see you go :(</div>
        </div>
      </div>
    );
  };

  const cancelSession = () => {
    setModalData({ ...ModalData, show: false, type: "" });
    setTransaction({ num: "", amount: "", date: "" });
  };
  useEffect(() => {
    setModalData({
      ...ModalData,
      desc: setCollect(),
    });
  }, [transaction]);
  useEffect(() => {
    const params = window.location.href.replace(/^https?:\/\/(www\.)?/, "");
    let type =
      params.split("/")[params.split("/")?.length - 1].split("?")[1] ?? "";
    setDropType(type);
  }, []);
  return (
    <div className="form-div knowledge">
      <div className="form-title">Hello {personalInfo?.firstName}!</div>
      {dropType === "impact" ? (
        <div className={`update-option ${dropType} md-desc`}>
          <div className={`update-left   `}>
            <div className="left-top md-title">Impact Survey</div>
            <div className="left-btm md-desc">
              We would love to know more about your experience with the
              Scholarship program. Please take out a couple of minutes to let us
              know :)
            </div>
          </div>
          <Button
            onClickHandler={() => getImpact()}
            type={"contained"}
            value={"View Assessment Form"}
          />
          {/* {dropType === "update" && (
            
          )} */}
        </div>
      ) : (
        <div className={`update-option ${dropType} md-desc`}>
          <div
            className={`update-left   ${dropType === "updated" && "set-title"}`}
          >
            <img src={dropType === "update" ? alert : clock} alt="alert" />
            {dropType === "update"
              ? "Update Transaction details to Complete Dropout Request"
              : "Your Dropout Request In Process"}
          </div>
          {dropType === "update" && (
            <Button
              onClickHandler={() =>
                setModalData({
                  ...ModalData,
                  show: true,
                  desc: setCollect(),
                  type: "collect",
                })
              }
              type={"contained"}
              value={"Update Details"}
            />
          )}
        </div>
      )}
      <div className="set-title">Knowledge / eLearning section</div>
      <div className="btn-row">
        <Button onClickHandler={() => {}} type={"contained"} value={"All"} />
        <Button
          onClickHandler={() => {}}
          type={"outlined-grey-2"}
          value={"Finance"}
        />
        <Button
          onClickHandler={() => {}}
          type={"outlined-grey-2"}
          value={"Marketing"}
        />
      </div>
      <div className="learning-content">
        <div className="content-top">
          <div className="item-1"></div>
        </div>
        <div className="content-btm">
          <div className="item-1 item md-desc">Communication platform</div>
          <div className="item-2 item md-desc">Survey section</div>
          <div className="item-1 item md-desc">Mentoring section</div>
        </div>
      </div>
      <FooterText />
      {ModalData.show && (
        <ModalComponent
          show={ModalData.show}
          handleClose={() => cancelSession()}
          title={ModalData.title}
          content={ModalData.desc}
          className="transaction-model"
          countDown={""}
        >
          <div className="modal-btn-set">
            {ModalData.type !== "clear" && (
              <Button
                disabled={
                  transaction.amount === "" ||
                  transaction.num === "" ||
                  transaction.date === ""
                }
                onClickHandler={() =>
                  setModalData({
                    ...ModalData,
                    show: true,
                    title: "",
                    desc: setConfirm(),
                    type: "clear",
                  })
                }
                type={"contained"}
                value={"Submit"}
              />
            )}

            <Button
              onClickHandler={() => cancelSession()}
              type={"only-text"}
              value={
                ModalData.type === "collect" ? "Cancel" : "Got it, Thanks!"
              }
            />
          </div>
        </ModalComponent>
      )}
      <FooterText />
    </div>
  );
}

export default KnowledgeSection;
